module.exports = __webpack_public_path__ + "static/ishi-fc4031aa80bed458cc25d52bf8a1a89d.svg";